import { EUserStatus } from '@xeppt/xeppt-sdk/types/user';
import { useUserContext } from '@hooks/context/useUserContext';
import { useLocales } from '@hooks/helpers/useLocales';
import { useKycModals } from '@hooks/modals/useKycModals';
import { useQueryParams } from '@hooks/helpers/useQueryParams';
import { useEffect } from 'react';
// import { useEffect, useState } from 'react';
// import { apiUserService } from '@api';

interface IProps {
    onSuccess?: () => void;
}

export const useVerificationResult = (data?: IProps) => {
    const { requestErrorLocale, requestSuccessLocale } = useLocales();
    const { refetchUser, handleChangeUserStatus } = useUserContext();
    const { handleOpenErrorModal, handleOpenSuccessModal } = useKycModals();
    // const [isFirstRender, setIsFirstRender] = useState(true);
    const [errorCodes] = useQueryParams(['kyc_errors']);

    const handleGetVerificationResult = (
        codes: string[],
        status: EUserStatus,
        ignoreNotification?: boolean
    ) => {
        if (status === EUserStatus.UNVERIFIED) {
            if (codes) {
                handleOpenErrorModal(codes);
            }
            if (!ignoreNotification) {
                handleChangeUserStatus(EUserStatus.UNVERIFIED);
                requestErrorLocale('failed_verify');
            }
        } else if (status === EUserStatus.ACTIVE && !ignoreNotification) {
            data?.onSuccess && data?.onSuccess();
            requestSuccessLocale('kyc_success');
            refetchUser();
            handleOpenSuccessModal();
        }
    };

    useEffect(() => {
        if (errorCodes) {
            const codesArray = errorCodes.split(',');
            handleOpenErrorModal(codesArray);
        }
    }, [errorCodes]);

    // const getVerificationsResult = () => {
    //     apiUserService.verificationResult().then(({ status, codes }) => {
    //         if (status === EUserStatus.PENDING) {
    //             setTimeout(() => getVerificationsResult(), 10000);
    //         }
    //         handleGetVerificationResult(codes, status);
    //     });
    // };

    // useEffect(() => {
    //     if (userStatus === EUserStatus.PENDING && isFirstRender) {
    //         setIsFirstRender(false);
    //         getVerificationsResult();
    //     }
    // }, [userStatus]);

    return {
        handleGetVerificationResult
    };
};
